export default __webpack_public_path__ + "static/media/killer_gf_01.e00074e3.jpg";